import React from 'react';

class BaseContent extends React.Component {

    render(){
        const style = {
            marginTop: 26, background: '#fff',minHeight: 530,borderRadius: 4,boxShadow:'0px 2px 4px 2px rgba(0, 66, 124, 0.1)',
            ...this.props.style
        };
        const footerStyle = {
            marginTop: 46,borderTop: '1px solid #EEEEEE', padding: '30px 0',
            ...this.props.footerStyle
        };
        delete this.props.style;
        return (
            <div {...this.props} style={style}>
                {this.props.children}
                {this.props.footer ? <div style={footerStyle}>{this.props.footer}</div> : null}
            </div>
        );
    }
};

export default BaseContent;



// WEBPACK FOOTER //
// ./src/components/BaseContent/index.js